import { User } from '../../features/auth/types/user';

interface TokenManager {
  accessToken: string | null;
  user: User | null;
  setTokens: (accessToken: string, user: User, expiresIn: number) => void;
  updateToken: (accessToken: string) => void;
  clearTokens: () => void;
  onTokensCleared: (callback: () => void) => void;
  offTokensCleared: (callback: () => void) => void;
}

class TokenManagerImpl implements TokenManager {
  private _accessToken: string | null = null;
  private _user: User | null = null;
  private _tokensClearedCallbacks: (() => void)[] = [];

  get accessToken(): string | null {
    return this._accessToken;
  }

  get user(): User | null {
    return this._user;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTokens(accessToken: string, user: User, _expiresIn: number): void {
    this._accessToken = accessToken;
    this._user = user;
  }

  updateToken(accessToken: string): void {
    this._accessToken = accessToken;
    // Keep existing user data, only update token
    console.log('🔄 TokenManager: Token updated');
  }

  clearTokens(): void {
    this._accessToken = null;
    this._user = null;
    console.log('🗑️ TokenManager: Tokens cleared');
    
    // Notify all registered callbacks
    this._tokensClearedCallbacks.forEach(callback => callback());
  }

  onTokensCleared(callback: () => void): void {
    this._tokensClearedCallbacks.push(callback);
  }

  offTokensCleared(callback: () => void): void {
    const index = this._tokensClearedCallbacks.indexOf(callback);
    if (index > -1) {
      this._tokensClearedCallbacks.splice(index, 1);
    }
  }
}

export const tokenManager = new TokenManagerImpl();
